import * as Form from "@radix-ui/react-form"

import { Search } from "@/components/search"

export const DialogSearch: React.FC<{
  value: string
  onChange: (value: string) => void
  placeholder?: string
}> = ({ value, onChange, placeholder }) => {
  return (
    <Form.Root
      className="w-full"
      onSubmit={(event) => {
        event.preventDefault()
      }}
    >
      <Search
        placeholder={placeholder ?? "Search..."}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="dialog"
      />
    </Form.Root>
  )
}

